const deleteServices = {
  toastr: 'Service deleted'
};

export default deleteServices;
